import { LDSAvatar, LDSDescriptionDetail, LDSDescriptionList, LDSHeading, LDSTag } from "@resmed/lumina-design-system";
import SvgAvatar from "../SvgAvatar";
import { PIN_ICON } from "../../utils/SVGHelper";

export interface ConversationListItemProps {
  name: string;
  subtitle: string;
  time: string;
  showExternal?: boolean;
  isSelected?: boolean;
  avatarImage?: string;
  avatarLabel?: string;
  /** "single" = one-to-one chat icon, "multiple" = group chat icon */
  icon?: "single" | "multiple";
  /** Show pin icon when this conversation is pinned */
  pinnedStatus?: boolean;
  /** Show unread badge (red dot) on avatar — mirrors mobile showBadge */
  unread?: boolean;
  onClick?: () => void;
}

const ConversationListItem = ({
  name,
  subtitle,
  time,
  showExternal = false,
  isSelected = false,
  avatarImage,
  icon = "single",
  pinnedStatus = false,
  unread = false,
  onClick,
}: ConversationListItemProps) => {
  return (
    <div
      className={`lds-flex lds-items-center lds-gap-3 lds-px-4 lds-py-3 lds-cursor-pointer ${
        isSelected
          ? "lds-bg-list-row-active"
          : "lds-bg-list-row-initial hover:lds-bg-list-row-hover"
      }`}
      onClick={onClick}
    >
      {/* Avatar container with unread badge — mirrors mobile BatchedProfileImage showBadge */}
      <div className="lds-relative">
        {avatarImage ? (
          <LDSAvatar size="medium" shape="circle" image={avatarImage} imageFallback="default" />
        ) : (
          <SvgAvatar icon={icon} size="medium" />
        )}
        {/* Red dot badge when unread — positioned top-right like mobile */}
        {unread && (
          <div className="lds-absolute lds-top-0 lds-right-0 lds-w-2.5 lds-h-2.5 lds-rounded-full lds-bg-red-600 lds-z-10 lds-translate-x-1/4 lds-translate-y-px lds-ring-2 lds-ring-white" />
        )}
      </div>

      {/* Title + Subtitle — apply bold font-weight to title when unread */}
      <div className="lds-flex-1 lds-min-w-0 lds-overflow-hidden">
        <LDSDescriptionList size="small" rootClassName="lds-min-w-0" width="100%">
          <LDSDescriptionDetail
            term={name}
            description={<span className="lds-block lds-truncate">{subtitle}</span>}
            dtContainerClassName={unread ? "lds-font-bold lds-truncate" : "lds-truncate"}
          />
        </LDSDescriptionList>
      </div>

      {/* Time + Pin icon + External Tag */}
      <div className="lds-flex lds-flex-col lds-items-end lds-shrink-0 lds-w-24 lds-gap-1">
        <div className="lds-flex lds-items-center lds-gap-1">
          {pinnedStatus && (
            <img
              src={PIN_ICON.src}
              alt={PIN_ICON.alt}
              width={PIN_ICON.width}
              height={PIN_ICON.height}
            />
          )}
          <LDSHeading
            size="h5"
            className="lds-text-xs lds-font-normal lds-leading-[125%] lds-tracking-normal lds-text-textcolor-weak lds-text-right lds-whitespace-nowrap lds-pt-[3px]"
          >
            {time}
          </LDSHeading>
        </div>
        {showExternal && (
          <LDSTag
            value="External"
            variant="default"
            removeIcon={true}
          />
        )}
      </div>
    </div>
  );
};

export default ConversationListItem;


